module.exports = __webpack_public_path__ + "img/logo.cae8218b.svg";